import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

// Actually this is for suppliers only, in the future it could be every company

export interface Company {
    _id: string;
    designation: string;
    codeProC: string;
    address?: string;
    longitude?: number;
    latitude?: number;
    area?: string;
    email?: string;
    phone?: string;
    crudStatus: number;
    isTempWorker?: boolean;
    isSubcontractor?: boolean;
    isGnrSupplier?: boolean;
    isToolSupplier?: boolean;
    isTransportCompany?: boolean;
    isQuarry?: boolean;
    isOwnCompany?: boolean;
    isSiteSupplier?: boolean;
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    usageCount?: {
        total: number;
    };
}

export interface CompaniesResponse {
    message: string;
    data: Company[];
}

export interface CompanyResponse {
    message: string;
    data: Company;
}

export interface GetCompaniesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllCompanies = async (queries?: GetCompaniesQueries): Promise<CompaniesResponse> => {
    try {
        const response: AxiosResponse<CompaniesResponse> = await apiClient.get('/companies', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateCompanyBody {
    designation: string;
    codeProC: string;
    address?: string;
    longitude?: number | null;
    latitude?: number | null;
    area?: string;
    email?: string;
    phone?: string;
    crudStatus?: number;
    isTempWorker?: boolean;
    isSubcontractor?: boolean;
    isGnrSupplier?: boolean;
    isToolSupplier?: boolean;
    isTransportCompany?: boolean;
    isQuarry?: boolean;
    isOwnCompany?: boolean;
    isSiteSupplier?: boolean;
}

export const createCompany = async (data: CreateCompanyBody): Promise<CompanyResponse> => {
    try {
        const response: AxiosResponse<CompanyResponse> = await apiClient.post('/companies', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateCompanyBody extends Partial<CreateCompanyBody> {}

export const updateCompany = async (companyId: string, data: UpdateCompanyBody): Promise<CompanyResponse> => {
    try {
        const response: AxiosResponse<CompanyResponse> = await apiClient.patch('/companies/' + companyId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
